import { SapSuppliersEdit } from "../../features"

const SapSuppliersEditPage = () => {
  return <SapSuppliersEdit />
}

export default SapSuppliersEditPage
